export default __webpack_public_path__ + "pdf/ThirdPartyAuthorization-VW.pdf";